require('backbone.paginator');
require('backbone-validation');
require('backbone.trackit');
Backbone.Validation.configure({
    forceUpdate: true
});

var CollectionChangesTrackingMixin = {
   hasUnsavedChanges: function () {
        var hasUnsavedChanges = false;
        var self = this;
        self.each(function (model) {
            if (model.hasUnsavedChanges()) {
                hasUnsavedChanges = true;
            }
        });
        return hasUnsavedChanges;
    },
    toggleTracking: function (on) {
        this._trackingChanges = on;
        this.each(function (model) {
            model[on ? 'startTracking' : 'stopTracking']();
        });
    },
    stopTracking: function () {
        this.toggleTracking(false);
    },
    startTracking: function () {
        this.toggleTracking(true);
    }
};

var MoveableItemsMixin = {
    moveUp: function(model) {
        var index = this.indexOf(model);
        if (index > 0) {
            this._swap(index, index - 1);
        }
    },
    moveDown: function(model) {
        var index = this.indexOf(model);
        if (index + 1 < this.models.length) {
            this._swap(index, index + 1);
        }
    },
    moveTo: function (model, moveToIndex) {
        var index = this.indexOf(model);
        if (moveToIndex >= 0 && moveToIndex <= this.models.length - 1) {
            if (Math.abs(index - moveToIndex) > 1) {
                this._inject(index, moveToIndex);
            } else {
                this._swap(index, moveToIndex);
            }
        }
    },
    _inject: function (indexA, indexB) {
        this.models.splice(indexB, 0, this.models.splice(indexA, 1)[0])
        this.trigger('item:moved', this.models[indexB], this);
    },
    _swap: function (indexA, indexB) {
        this.models[indexA] = this.models.splice(indexB, 1, this.models[indexA])[0];
        this.trigger('item:moved', this.models[indexA], this);
    }
};

var commonFunctionsMixin = {
    url: function () {
        return FarmacyPluginAjax.ajaxurl;
    },
    sync: function(method, model, options) {
        var self = this;
        var methodMap = {
            'create': 'POST',
            'update': 'POST',
            'patch':  'POST',
            'delete': 'POST',
            'read':   'GET'
        };

        var noXhrPatch =
            typeof window !== 'undefined' && !!window.ActiveXObject &&
            !(window.XMLHttpRequest && (new XMLHttpRequest).dispatchEvent);

        var type = methodMap[method];
        var methodToActionMap =
            this.methodToActionMap ||
            this.model.prototype.methodToActionMap;

        if (!methodToActionMap) {
            throw new Error('methodToActionMap not configured');
        }

        var action = methodToActionMap[method];
        if (!action) {
            throw new Error('action not found in methodToActionMap');
        }

        // Default options, unless specified.
        _.defaults(options || (options = {}), {
            emulateHTTP: Backbone.emulateHTTP,
            emulateJSON: Backbone.emulateJSON
        });

        // Default JSON-request options.
        var params = {
            type: type,
            dataType: 'json'
        };
        options = options || {};
        options.data = options.data || {};
        options.data.security = FarmacyPluginAjax.FarmacyNonce;
        if (Backbone.Radio) {
            options.data.pubnubuuid = Backbone.Radio.channel('pubsub').request('getUUID');
        }

        options.data.action = action;
        options.emulateJSON = true;

        // Ensure that we have a URL.
        if (!options.url) {
            params.url = _.result(model, 'url') || urlError();
        }

        // Ensure that we have the appropriate request data.
        if (model && (method === 'create' || method === 'update' || method === 'patch' ||  method === 'delete')) {
            params.contentType = 'application/x-www-form-urlencoded';
            _.extend(options.data, {
                entity: JSON.stringify(options.attrs || model.toJSON(options))
            });
        }

        // backbone.trackit changes added here because we're overriding sync
        // and so do they.
        // backbone.trackit changes start
        if (method == 'update' || method == 'create' || method == 'patch') {
            options.success = _.wrap(options.success, _.bind(function(oldSuccess, data, textStatus, jqXHR) {
              var ret;
              if (oldSuccess) ret = oldSuccess.call(this, data, textStatus, jqXHR);
              if (model._trackingChanges) {
                model._resetTracking();
                model._triggerUnsavedChanges();
              }
              return ret;
            }, this));
        }
        // backbone.trackit changes end

        // For older servers, emulate HTTP by mimicking the HTTP method with `_method`
        // And an `X-HTTP-Method-Override` header.
        if (options.emulateHTTP && (type === 'PUT' || type === 'DELETE' || type === 'PATCH')) {
            params.type = 'POST';
            if (options.emulateJSON) params.data._method = type;
            var beforeSend = options.beforeSend;
            options.beforeSend = function(xhr) {
                xhr.setRequestHeader('X-HTTP-Method-Override', type);
                if (beforeSend) return beforeSend.apply(this, arguments);
            };
        }

        // Don't process data on a non-GET request.
        if (params.type !== 'GET' && !options.emulateJSON) {
            params.processData = false;
        }

        // If we're sending a `PATCH` request, and we're in an old Internet Explorer
        // that still has ActiveX enabled by default, override jQuery to use that
        // for XHR instead. Remove this line when jQuery supports `PATCH` on IE8.
        if (params.type === 'PATCH' && noXhrPatch) {
            params.xhr = function() {
                return new ActiveXObject("Microsoft.XMLHTTP");
            };
        }

        // Make the request, allowing the user to override any Ajax options.
        var xhr = options.xhr = Backbone.ajax(_.extend(params, options));
        if (method === 'read') {

            var fetchEnded = function () {
                self.fetching = false;
                self.trigger('fetch:end', self);
            };

            var fetchStarted = function (model, xhr) {
                self.fetching = true;
                xhr.fail(fetchEnded.bind(self));
                self.trigger('fetch:start', self);
            };

            self.on('request', fetchStarted);
            self.on('sync error', fetchEnded);
            xhr.always(function () {
                self.off('sync error', fetchEnded);
                self.off('request', fetchStarted);
            });
        }
        xhr.then(function () {
            var nonce = xhr.getResponseHeader('X-WP-FarmacyNonce');
            if (nonce) {
                console.log('new nonce passed: ' + nonce);
                FarmacyPluginAjax.FarmacyNonce = nonce;
            }
        });
        model.trigger('request', model, xhr, options);
        return xhr;
    }
};

var CollectionNavigationMixin = {
    next: function(model) {
        var i = this.at(this.indexOf(model));
        if (undefined === i || i < 0) return false;
        return this.at(this.indexOf(model) + 1);
    },
    prev: function(model) {
        var i = this.at(this.indexOf(model));
        if (undefined === i || i < 1) return false;
        return this.at(this.indexOf(model) - 1);
    }
};

var UnsavedChangesHandlingMixin = {
    unsavedChangesIgnoredAttributes: [],
    // unsaved is the backbone.trackit configuration key.
    // We handle route based prompts but use backbone-trackit for
    // the window prompts.
    unsaved: {
        unloadWindowPrompt: function () {
            return this.hasUnsavedChanges();
        }
    },
    hasUnsavedChanges: function (attr) {
        var hasUnsavedChanges = false;
        var self = this;
        if (attr) {
            hasUnsavedChanges = _.has(this.unsavedAttributes(), attr);
        } else {
            _.each(this.unsavedAttributes(), function (value, key, list) {
                if (self.unsavedChangesIgnoredAttributes.indexOf(key) === -1) {
                    hasUnsavedChanges = true;
                }
            });
        }

        return hasUnsavedChanges;
    }
};

var NestedEntitiesHandlingMixin = {
    nestedEntities: {
        // Key of attribute that will hold the entity
        // with entity type to create. For example:
        // tag_set: Collections.CollectionBase,
    },
    createNestedEntityClass: function (entityKey, entityData) {
        var entityClass = this.nestedEntities[entityKey];
        return new entityClass(
            entityData,
            {
                parse: true
            }
        );
    },
    setNestedEntityClass: function (entityKey, entityData) {
        var entity = this.get(entityKey);

        if (entity instanceof Backbone.Collection) {
            entity.reset(entityData, { parse: true });
        } else {
            entity.set(entity.parse(entityData || {}));
        }
    },
    parse: function (response) {
        var self = this;
        for (var key in self.nestedEntities) {
            if (!self.nestedEntities.hasOwnProperty(key)) {
                continue;
            }
            var existingEntity = self.get(key);
            if (existingEntity instanceof Backbone.Model ||
                existingEntity instanceof Backbone.Collection)
            {
                // TODO rtomaselli the problem with setting here is
                // that any events fired during the set will be
                // fired before the parent entities events get fired
                // which could be problematic. Really we should be
                // overriding the set method for nested entity
                // handling.
                // For an example see: https://github.com/blittle/backbone-nested-models
                self.setNestedEntityClass(key, response[key]);
                response[key] = existingEntity;
                continue;
            }

            var entityData = response[key];
            if (entityData instanceof Backbone.Model ||
                entityData instanceof Backbone.Collection) {
                // Attribute previously set to an entity instance
                // so no more to do.
                continue;
            }

            response[key] = self.createNestedEntityClass(key, response[key]);
        }
        return Backbone.Model.prototype.parse.call(this, response);
    },
    toJSON: function() {
        var json = _.clone(this.attributes);
        if (this.nestedEntities) {
            for (var key in this.nestedEntities) {
                if (json[key] && json[key].toJSON) {
                    json[key] = json[key].toJSON();
                }
            }
        }
        for (var attr in json) {
            if ((json[attr] instanceof Backbone.Model) || (json[attr] instanceof Backbone.Collection)) {
                json[attr] = json[attr].toJSON();
            }
        }
        return json;
    }
};

var ModelBase = Backbone.Model.extend({
    initialize: function (attrs, options) {
        var self = this;
        self.options = _.defaults(
            options || {},
            {
                tracking: options && options.tracking ?
                    options.tracking :
                    self.collection &&
                    self.collection._trackingChanges
            }
        );

        self._trackingChanges = self.options.tracking;
        if (self._trackingChanges) {
            self.startTracking();
        }
        self.on('error', self.handleError.bind(self));
    },
    handleError: function (model, resp, options) {
        var self = this;
        try {
            var errors = resp.validation;
            if (!errors) {
                return;
            }
            _.each(errors, function (val, attr) {
                _.each(model.associatedViews, function(view) {
                    Backbone.Validation.callbacks.invalid(view, attr, val.message, 'name');
                });
            });
            _.defer(function() {
                model.trigger('validated', false, model, errors);
                model.trigger('validated:invalid', model, errors);
            });
        } catch (error) {}
    },
    fetchParams: function () {
        return {
            id: this.id
        };
    },
    fetch: function (options) {
        var opts = _.defaults(options || {});
        opts.data = _.defaults(
            opts.data || {},
            this.fetchParams()
        );

        return Backbone.Model.prototype.fetch.call(
            this,
            opts
        );
    },
    suppressValidationForAttribute: function (attr) {
        if (this.validation) {
            this.validation[attr] = false;
        }
    }
});
_.extend(ModelBase.prototype, NestedEntitiesHandlingMixin);
_.extend(ModelBase.prototype, commonFunctionsMixin);
_.extend(ModelBase.prototype, UnsavedChangesHandlingMixin);

var CollectionBase = Backbone.Collection.extend({
    constructor: function(models, options) {
        this.cid = _.uniqueId('c');
        Backbone.Collection.prototype.constructor.call(this, models, options);
    },
    fetchParams: function () {
        return {};
    },
    fetch: function (options) {
        var opts = _.defaults(options || {});
        opts.data = _.defaults(
            opts.data || {},
            this.fetchParams()
        );

        return Backbone.Collection.prototype.fetch.call(
            this,
            opts
        );
    }
});
_.extend(CollectionBase.prototype, MoveableItemsMixin);
_.extend(CollectionBase.prototype, commonFunctionsMixin);
_.extend(CollectionBase.prototype, CollectionNavigationMixin);

var SORT_DIRECTIONS = {
    ASC: -1,
    DESC: 1,
    NATURAL: 0
};

var PageableCollectionBase = Backbone.PageableCollection.extend({
    constructor: function(models, options) {
        this.cid = _.uniqueId('c');
        Backbone.PageableCollection.prototype.constructor.call(this, models, options);
    },
    setQueryParam: function (keysOrObj, value) {
        var self = this;
        function setKey (key, value) {
            if (_.isUndefined(value) || _.isNull(value)) {
                delete self.queryParams[key];
            } else {
                self.queryParams[key] = value;
            }
        }
        if (_.isObject(keysOrObj)) {
            _.each(keysOrObj, function (value, key, list) {
                setKey(key, value);
            });
        } else {
            setKey(keysOrObj, value);
        }
    },
    _prepareModel: function (attrs, options) {
        if (attrs instanceof Backbone.Model) return attrs;
        options = options ? _.clone(options) : {};
        options.collection = this;
        var model;
        if (_.isFunction(this.createModel)) {
            model = this.createModel.call(this, attrs, options);
        } else {
            model = new this.model(attrs, options);
        }
        if (!model.validationError) return model;
        this.trigger('invalid', this, model.validationError, options);
        return false;
    },
    queryParams: {
        pageSize: 'per_page'
    },
    parseState: function (resp, queryParams, state, options) {
        function getValueFromResponseHeader(keyName) {
            if (options.xhr) {
                var parsed = parseInt(options.xhr.getResponseHeader(keyName), 10);
                if (isNaN(parsed)) {
                    return 0;
                } else {
                    return parsed;
                }
            } else {
                return 0;
            }
        }

        return {
            totalRecords: getValueFromResponseHeader('X-WP-Total'),
            totalPages: getValueFromResponseHeader('X-WP-TotalPages')
        };
    },
    state: {
        pageSize: 50,
        order: SORT_DIRECTIONS.DESC
    }
});
_.extend(PageableCollectionBase.prototype, MoveableItemsMixin);
_.extend(PageableCollectionBase.prototype, commonFunctionsMixin);
_.extend(PageableCollectionBase.prototype, CollectionChangesTrackingMixin);

module.exports = {
    CollectionNavigationMixin: CollectionNavigationMixin,
    MoveableItemsMixin: MoveableItemsMixin,
    CollectionBase: CollectionBase,
    UnsavedChangesHandlingMixin: UnsavedChangesHandlingMixin,
    NestedEntitiesHandlingMixin: NestedEntitiesHandlingMixin,
    CollectionChangesTrackingMixin: CollectionChangesTrackingMixin,
    PageableCollectionBase: PageableCollectionBase,
    ModelBase: ModelBase,
    SORT_DIRECTIONS: SORT_DIRECTIONS
};



/** WEBPACK FOOTER **
 ** ./assets/js/entities/base.js
 **/